import Config from './app.config.js'
import appCache from './app.service.cache.js'

let wordpressService = {
  cacheRequest(path, cacheTime) {
    return new Promise((resolve, reject) => {
      appCache.get(path, cacheTime)
        .then(response => { resolve(response) })
        .catch(err => { reject(err) })
    })
  },
  getHomepage() {
    return new Promise((resolve, reject) => {

      let path = Config.wpDomain + `wp-json/amaroutes/homepage`
      this.cacheRequest(path, 0)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },
  getPage(pageSlug) {
    return new Promise((resolve, reject) => {
      let path = Config.wpDomain + `wp-json/amaroutes/get_page_by_slug/${pageSlug}`
      this.cacheRequest(path, 0)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },
  getPost(pageId, pageSlug) {
    return new Promise((resolve, reject) => {
      // console.log(pageSlug)
      // let pageId = false
      let path = Config.wpDomain + `wp-json/wp/v2/pages/${pageId}`
      if (!pageId && pageSlug) {
        path = Config.wpDomain + `wp-json/amaroutes/get_post_by_slug/${pageSlug}`
      }
      this.cacheRequest(path, 0)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },
  getPosts(getConditions) {
    return new Promise((resolve, reject) => {
      let path = Config.wpDomain + `wp-json/amaroutes/posts?page=${getConditions.page}&archive=${getConditions.archive}&category=${getConditions.category}`
      this.cacheRequest(path, 0)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  }
}

export default wordpressService
